import { setEqualHeightWithCondition } from './equalHeight.js';

setEqualHeightWithCondition( '.e-stn--stat-grid .row', '.e-ctr__d', () => window.innerWidth > 768, 200 );